"use client";

import { c as _c } from "react/compiler-runtime";
import { IconMoon, IconSun } from "@tabler/icons-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";
const ThemeToggle = () => {
  const $ = _c(7);
  const {
    resolvedTheme,
    setTheme
  } = useTheme();
  let t0;
  if ($[0] !== resolvedTheme || $[1] !== setTheme) {
    t0 = () => setTheme(resolvedTheme === "dark" ? "light" : "dark");
    $[0] = resolvedTheme;
    $[1] = setTheme;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconSun className="group-hover:stroke-orange-600 dark:hidden" aria-hidden="true" />;
    t2 = <IconMoon className="not-dark:hidden group-hover:stroke-yellow-400" aria-hidden="true" />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0) {
    t3 = <Button variant="ghost" size="icon" onClick={t0} aria-label="Toggle theme" className="group">{t1}{t2}</Button>;
    $[5] = t0;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export { ThemeToggle };